import { render, staticRenderFns } from "./ListasPrecioMonitor.vue?vue&type=template&id=c17a9b02&scoped=true&"
import script from "./ListasPrecioMonitor.vue?vue&type=script&lang=js&"
export * from "./ListasPrecioMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ListasPrecioMonitor.vue?vue&type=style&index=0&id=c17a9b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17a9b02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCheckbox,VContainer,VFadeTransition,VIcon,VProgressCircular,VSpacer})
